import api from '../config/axios.js';

export async function isAuthenticated() {
  try {
    const response = await api.axios.get('/api/user');
    return !!response.data;
  } catch (error) {
    if (error && error.response && error.response.status === 403) {
      return true;
    }

    return false;
  }
}

export async function login(email, password) {
  return api.axios.post('/login', { email, password });
}

export async function logout() {
  return api.axios.post('/api/logout');
}
